module.exports = __webpack_public_path__ + "img/dsh.209b4913.png";